import { HIDDEN_LEAGUE_NAME_PARTS } from './customerSpecific.config';

const getDisplayedLeagueName = (
  leagueName: string,
  leagueId: number,
  customer: string | undefined
): string => {
  const hiddenParts = (customer && HIDDEN_LEAGUE_NAME_PARTS[customer]?.[leagueId]) || [];

  return hiddenParts
    .reduce((name, part) => name.split(part).join(' '), leagueName)
    .replace(/\s+/g, ' ')
    .trim();
};

export { getDisplayedLeagueName };
